export default function () {
  return {
    type: 'TOGGLE MENU',
  };
}
